import { Component, OnInit } from "@angular/core";
import { UserService } from "@app/core/user.service";
import { enterAnimation } from "@app/shared/page-state/animations";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

@Component({
  selector: "om-get-help-hero",
  templateUrl: "./get-help-hero.component.html",
  styleUrls: ["./get-help-hero.component.scss"],
  animations: [enterAnimation],
})
export class GetHelpHeroComponent implements OnInit {
  constructor(
    public userService: UserService,
    private homePageAnalyticsService: HomePageAnalyticsService
  ) {}

  ngOnInit() {
    this.userService.getUser();
    this.homePageAnalyticsService.trackHeroBookVisitLink("om-get-help-hero .call-to-action");
    this.homePageAnalyticsService.trackHeroMessageUsLink("om-get-help-hero .message-us");
  }
}
